import { render, staticRenderFns } from "./NetWorth.vue?vue&type=template&id=2e5ef2ed&scoped=true&"
import script from "./NetWorth.vue?vue&type=script&lang=js&"
export * from "./NetWorth.vue?vue&type=script&lang=js&"
import style0 from "./NetWorth.vue?vue&type=style&index=0&id=2e5ef2ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5ef2ed",
  null
  
)

export default component.exports